import { useSelector } from "react-redux";
import { i18n } from "app/i18n/i18n";
import { createAnalystQueryBody } from "./createAnalystQueryBody";
import { isPublicPath } from "lib/routing";
const { useFetch } = require("lib/useFetch");
const ANALYST_DATA_URL = "/research/japi/analysts/analyst_specialities";
const ANALYST_DATA_PUBLIC_URL = "/research/japi/public/analysts/analyst_specialities";
const LEGACY_IMAGE_URL_PREFIX = "/research/v1/pages/DisplayAnalystImage.aspx?categoryid=";
const JAPI_IMAGE_URL_PREFIX = "/research/japi/public/analysts/image/";

export const useFetchAnalystData = () => {
  const queryString = useSelector((state) => state.filter.qs);
  const url = isPublicPath() ? ANALYST_DATA_PUBLIC_URL : ANALYST_DATA_URL;
  const [data, loading, error] = useFetch(url, createAnalystQueryBody(queryString), "POST");
  const hits = data.hits ? tryProcessData(data) : [];
  const analysts = groupByViewAndSpecialty(hits);
  const aggs = parseAggegrations(data.aggregations);
  return [analysts, loading, error, data, hits, aggs];
};

function tryProcessData(data) {
  try {
    return data.hits.hits.map((record) => record._source);
  } catch (err) {
    console.error("Error processing analyst data", err, data);
    return [];
  }
}

/*
Groups analysts by view and speciality, returns { [group]: { [speciality]: [analysts] } }
e.g. { "macro": { "credit": [ {firstName:"john", lastName:"smith"} ]} }
*/
function groupByViewAndSpecialty(hits) {
  return hits.reduce((acc, analyst) => {
    const lang = i18n.getLanguage();

    // try update legacy server image urls. TODO remove once backend urls are updated.
    analyst.imageURL = analyst.imageURL ? analyst.imageURL.replace(LEGACY_IMAGE_URL_PREFIX, JAPI_IMAGE_URL_PREFIX) : "";

    if (!analyst.speciality || !analyst.speciality.group[lang] || !analyst.speciality.speciality[lang]) {
      console.warn("Excluding analyst with no group or speciality:", analyst);
      return acc; // exclude any analysts without speciality
    }

    const group = analyst.speciality.group[lang];
    const speciality = analyst.speciality.speciality[lang];

    acc[group] = acc[group] || {};
    acc[group][speciality] = (acc[group][speciality] || []).concat(analyst);

    return acc;
  }, {});
}

function parseAggegrations(aggs = {}) {
  let ret = {};
  try {
    ret.speciality = (aggs?.speciality?.speciality?.buckets || []).map((bucket) => bucket.key);
    ret.region = (aggs?.region?.region?.buckets || []).map((bucket) => bucket.key);
  } catch (err) {
    console.error("Error parsing analyst aggregations", err);
  }
  return ret;
}
